import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Main } from './main/Main';

export const YoutubeRoutes = () => {
  return (
    <Switch>
      <Route path='/youtube/upload' component={Main} />
    </Switch>
  );
};
